import * as ObjectExtensions from "../../../utils/CoreExtensions/ObjectExtensions";

const upcomingConversationWidgetReducers = {
  setUpcomingConversationWidget: (state, action) => {
    state.upcomingConversationWidget = action.payload;
  },
  updateUpcomingConversationWidget: (state, action) => {
    state.upcomingConversationWidget = ObjectExtensions.deepMerge(state.upcomingConversationWidget, action.payload);
  },
  reloadUpcomingConversationWidget: (state, action) => {
    state.upcomingConversationWidget.reloadWidget = action.payload;
  },
  showLoaderForUpcomingConversationWidget: (state, action) => {
    state.upcomingConversationWidget.showLoader = action.payload;
  }
}

export default upcomingConversationWidgetReducers;
